<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="tp2">The Myth of the<br/>
    Non-Christian</p>
<p class="tp3">Engaging Atheists, Nominal Christians<br/>
    and the Spiritual But Not Religious</p>
<p class="center"><img alt="" class="img50" src="Images/4450_crowd1.png"/></p>
<p class="tp4">    Luke Cawley<br/>
<br/></p>
<p class="firstcenter"><a href="http://www.ivpress.com/books" target="_blank"><img alt="" src="Images/IVP_Books_Logo.png"/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?246fb7b7